module.exports = __webpack_public_path__ + "static/messenger-examples-f753df6069ba32b201001d2d874b3078.jpg";